import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material';
import { MessageDialogData } from '@app/shared/components/dialogs/message-dialog/message-dialog.data';

@Component({
    selector : 'message-dialog',
    template: require('./message-dialog.component.html'),
    styles: [require('./message-dialog.component.scss')]
})
export class MessageDialogComponent {
    constructor(@Inject(MAT_DIALOG_DATA) public data: MessageDialogData) {
    }

}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/shared/components/dialogs/message-dialog/message-dialog.component.ts